











import { Vue, Component, Prop } from "vue-property-decorator";
import { HeaderSetting } from "../types";
import TooltipIcon from "@share/common/TooltipIcon.vue";

@Component({ components: { TooltipIcon }})

export default class JConfTableHeader extends Vue {
    @Prop() headerSettings: HeaderSetting[];
}

